let phoneNumberCache;

export async function getGooglePhoneLib(): Promise<typeof libphonenumber> {
    if (!phoneNumberCache) {
        phoneNumberCache = await import('google-libphonenumber');
    }
    return phoneNumberCache;
}